import React from 'react';
import PhotoRelease from '../domains/legal/components/PhotoRelease';

const PhotoReleasePage: React.FC = () => {
  return <PhotoRelease />;
};

export default PhotoReleasePage;


